import { fromJS } from 'immutable';

import {
  REQUEST_NOTIFICATIONS,
  REQUEST_NOTIFICATIONS_SUCCESS,
  REQUEST_NOTIFICATIONS_FAILURE,
  START_NOTIFICATION_POLLING,
  STARTED_NOTIFICATION_POLLING,
  STOP_NOTIFICATION_POLLING,
  NOTIFICATION_POLLING_SUCCESS,
  REQUEST_MARK_AS_SEEN,
  REQUEST_MARK_AS_READ,
} from './types';

const initialState = fromJS({
  page: 1,
  list: false,
  hasMore: false,
  polling: false,
  network: { loading: false, error: false },
});

export function requestNotifications(page) {
  return {
    type: REQUEST_NOTIFICATIONS,
    page,
  };
}

export function requestNotificationsSuccess(response, page) {
  return {
    type: REQUEST_NOTIFICATIONS_SUCCESS,
    response,
    page,
  };
}

export function requestNotificationsFailure(error) {
  return {
    type: REQUEST_NOTIFICATIONS_FAILURE,
    error,
  };
}

export function startNotificationPolling() {
  return {
    type: START_NOTIFICATION_POLLING,
  };
}

export function startedNotificationPolling() {
  return {
    type: STARTED_NOTIFICATION_POLLING,
  };
}

export function stopNotificationPolling() {
  return {
    type: STOP_NOTIFICATION_POLLING,
  };
}

export function notificationPollingSuccess(response) {
  return {
    type: NOTIFICATION_POLLING_SUCCESS,
    response,
  };
}

export function requestMarkAsSeen(notificationIds) {
  return {
    type: REQUEST_MARK_AS_SEEN,
    notificationIds,
  };
}

export function requestMarkAsRead(notification) {
  return {
    type: REQUEST_MARK_AS_READ,
    notification,
  };
}

function filterNewNotifications(oldList, newList) {
  return newList.filter(
    (newVal) => !oldList.find((oldVal) => newVal.get('id') === oldVal.get('id')),
  );
}

function appendNotifications(oldList, newList) {
  if (!oldList) {
    return newList;
  }

  return oldList.concat(filterNewNotifications(oldList, newList));
}

function prependNotifications(oldList, newList) {
  if (!oldList) {
    return newList;
  }

  return filterNewNotifications(oldList, newList).concat(oldList);
}

export default function notificationsReducer(state = initialState, action) {
  switch (action.type) {
    case REQUEST_NOTIFICATIONS:
      return state.setIn(['network', 'loading'], true);
    case REQUEST_NOTIFICATIONS_SUCCESS:
      return state.withMutations((s) =>
        s
          .setIn(['network', 'loading'], false)
          .setIn(['network', 'error'], false)
          .update('list', (oldList) =>
            appendNotifications(oldList, fromJS(action.response.notifications)),
          )
          .set('hasMore', action.response.hasMore)
          .update('page', (page) => action.page || page),
      );
    case REQUEST_NOTIFICATIONS_FAILURE:
      return state.withMutations((s) =>
        s
          .setIn(['network', 'loading'], false)
          .setIn(['network', 'error'], action.error)
          .set('list', false),
      );
    case STARTED_NOTIFICATION_POLLING:
      return state.set('polling', true);
    case STOP_NOTIFICATION_POLLING:
      return state.set('polling', false);
    case NOTIFICATION_POLLING_SUCCESS:
      return state.withMutations((s) =>
        s
          .update('list', (oldList) =>
            prependNotifications(oldList, fromJS(action.response.notifications)),
          )
          .set('hasMore', action.response.hasMore),
      );
    case REQUEST_MARK_AS_SEEN:
      return state.update('list', (list) => list.map((n) => n.set('seen', true)));
    default:
      return state;
  }
}
